import { render, staticRenderFns } from "./FunnelWarning.vue?vue&type=template&id=e5521358"
import script from "./FunnelWarning.vue?vue&type=script&lang=js"
export * from "./FunnelWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports